import { isNavGroup, NavGroup, NavLink, selectNavLinks } from '~/app/navLinks'
import { pages } from '~/app/routes'
import { useFlag } from '~/hooks/useFlag'
import { useStore } from '~/store/store'

export const useNavLinks = () => {
    const navLinks = useStore(selectNavLinks)

    const isInsightsEnabled = useFlag('insights_page__enabled')
    const isHospitalConfigurationPageEnabled = useFlag('hospital_configuration_page__enabled')
    const isCommandPaletteEnabled = useFlag('command_palette')
    const isInboxEnabled = useFlag('inbox')

    function isNavLinkHidden(navLink: Partial<NavLink> & { title: NavLink['title'] }) {
        if (navLink.title === 'Søk') {
            return !isCommandPaletteEnabled
        }

        if (navLink.title === 'Innboks') {
            return !isInboxEnabled
        }

        if (navLink.title === pages.INSIGHTS.title) {
            return !isInsightsEnabled
        }

        if (navLink.title === pages.HOSPITAL_CONFIGURATION.title) {
            return !isHospitalConfigurationPageEnabled
        }

        return false
    }

    function filterNavEntries(entries: (NavGroup | NavLink)[]): (NavGroup | NavLink)[] {
        return entries.reduce<(NavGroup | NavLink)[]>((acc, entry) => {
            if (isNavGroup(entry)) {
                const filteredItems = entry.items.filter(item => !isNavLinkHidden(item))
                if (filteredItems.length > 0) {
                    acc.push({ ...entry, items: filteredItems })
                }
            } else if (!isNavLinkHidden(entry)) {
                acc.push(entry)
            }
            return acc
        }, [])
    }

    const filtered = filterNavEntries(navLinks)

    return {
        allNavLinks: navLinks,
        filteredNavLinks: filtered,
        filteredFlatNavLinks: filtered.flatMap(entry => (isNavGroup(entry) ? entry.items : [entry])),
    }
}
